import { HTTP_TOKEN_REPORT } from "./http";

export const getFilters = (params) => {
  return HTTP_TOKEN_REPORT.get("report-filter", { params }).then((result) => {
    return result.data;
  });
};
